export { PromotionsComponent } from './promotions/promotions.component';
export { PromotionsService } from './promotions/promotions.service';
